export enum DocumentTypeEnum {
  PRIVACY_POLICY,
  TERMS_OF_USE,
  COOKIE_POLICY,
}
